import React,{ useState } from "react";
import { useNavigate } from "react-router-dom";
import box from "../../../assets/box.svg";
import send from "../../../assets/send.svg";
import cart from "../../../assets/cart.svg";
import location from "../../../assets/locationBlue.svg";
import dottedBox from "../../../assets/dottedBox.svg";
import { Button, InputGroup } from "../../../UI";
import order from "../../../assets/order.svg";
import orderEllipse from "../../../assets/orderEllipse.svg";
import Container from "./styles";
import Orders from "../Orders";
import {useDispatch} from 'react-redux'
import {getOrderByTrackingNo} from '../../../store/actions'

const Jumbotron = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [tracker, setTracker] = useState()
  const [clicked, setClicked] = useState(false)


  return (
    <Container>
      <img src={box} className="floating--img img--left__top" alt="scooter" />
      <img
        src={cart}
        className="floating--img img--left__bottom"
        alt="scooter"
      />
      <img src={send} className="floating--img img--right__top" alt="scooter" />
      <img
        src={location}
        className="floating--img img--right__bottom"
        alt="scooter"
      />
      <div className="ellipse--container">
        <img src={orderEllipse} alt="Ellipse" />

        <h1>Track your orders</h1>
        <h2>Follow up with your orders to know the state of your orders</h2>
      </div>
      <div className="img--container">
        <img src={order} alt="order" />
      </div>
      <form>
        <InputGroup>
          <input placeholder={"Enter your tracking ID"}  onChange={(e)=>{setTracker(e.target.value)}}/>
          <Button
          onClick={() =>{
            setClicked(true)
            dispatch(getOrderByTrackingNo({"tracking_number":tracker}))
          }}
          >Track</Button>
        </InputGroup>
      </form>
      <img src={dottedBox} className="dottedBox--img" alt="scooter" />
      <Orders  clicked={clicked}/>
    </Container>
  );
};

export default Jumbotron;
